import axios from "axios";
import authHeader from '../../../authheader'

const LSIAPPLICATIONURL = process.env.REACT_APP_APIURL + "/api/IndividualLsiReinstatement";



const getBoardRecommendations = (reinstatementId) => {
    return axios.get(`${LSIAPPLICATIONURL}/boardrecommendations`, { headers: authHeader(), params: { reinstatementId } });
}
const getBoardResponses = (reinstatementId) => {
    return axios.get(`${LSIAPPLICATIONURL}/boardmemberresponses`, { headers: authHeader(), params: { reinstatementId } });
}
const postBoardRecommendation = (data) => {
    return axios.post(`${LSIAPPLICATIONURL}/boardrecommendation`, data, { headers: authHeader() });
}
const postBoardResponse = (data) => {
    var header = authHeader();
    header['Content-Type'] = 'multipart/form-data';
    return axios.post(`${LSIAPPLICATIONURL}/boardmemberresponse`, data, { headers: { ...header } });
}
export default {
    getBoardRecommendations,
    getBoardResponses,
    postBoardRecommendation,
    postBoardResponse
}